module.exports = __webpack_public_path__ + "img/image_certificate.ea82a957.png";